module.exports = __webpack_public_path__ + "img/galerie-47.4db5c515.jpg";